<template>
  <section class="hero">
    <div class="hero-bg-overlay"></div>
    <div class="container">
      <div class="hero-content">
        <div class="hero-badge">🔥 本地搜图 · 无需连网 · 保护隐私</div>
        <h1 class="hero-title">
          简单清爽的界面<br>高配满血AI算法引擎
        </h1>
        <p class="hero-desc">
          理解力和速度都拉满，搜人搜车搜物，图片或视频，交给它就行。
        </p>
        <div class="hero-actions">
          <a href="https://pan.quark.cn/s/5817af286fd9#/list/share" target="_blank" class="btn-outline">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
            夸克网盘(推荐)
          </a>
          <a href="https://pan.baidu.com/s/5pVyYCYYoedfOENwxp4UEXw?#list/path=%2F%E5%8D%83%E5%AF%BB%E6%90%9C%E5%9B%BE" target="_blank" class="btn-outline">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
            网盘下载
          </a>
        </div>
      </div>
      <div class="hero-image">
        <div class="image-container">
          <img :src="currentImage" :alt="'KiloSeek千寻搜图软件界面 ' + (currentIndex + 1)">
          <div class="image-navigation">
            <button @click="prevImage" class="nav-button prev" aria-label="上一张">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>
            </button>
            <button @click="nextImage" class="nav-button next" aria-label="下一张">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>
            </button>
          </div>
          <div class="image-indicators">
            <span
              v-for="(image, index) in heroImages"
              :key="index"
              :class="{ active: index === currentIndex }"
              @click="goToImage(index)"
            ></span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'SiteHero',
  data() {
    return {
      currentIndex: 0,
      heroImages: [
        require('@/assets/hero1.png'),
        require('@/assets/hero2.png'),
        require('@/assets/hero3.png'),
        require('@/assets/hero4.png'),
      ]
    }
  },
  computed: {
    currentImage() {
      return this.heroImages[this.currentIndex]
    }
  },
  methods: {
    scrollToSection(sectionId) {
      const element = document.getElementById(sectionId)
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' })
      }
    },
    nextImage() {
      this.currentIndex = (this.currentIndex + 1) % this.heroImages.length
    },
    prevImage() {
      this.currentIndex = (this.currentIndex - 1 + this.heroImages.length) % this.heroImages.length
    },
    goToImage(index) {
      this.currentIndex = index
    }
  }
}
</script>

<style scoped>
.hero {
  padding: 140px 0 80px;
  position: relative;
  overflow: hidden;
  background: linear-gradient(160deg, #f0f7ff 0%, #e8f4fd 40%, #f8fbff 100%);
}

.hero-bg-overlay {
  position: absolute;
  top: -50%;
  right: -20%;
  width: 800px;
  height: 800px;
  background: radial-gradient(circle, rgba(78, 140, 255, 0.08) 0%, transparent 70%);
  pointer-events: none;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 32px;
  display: flex;
  align-items: center;
  gap: 60px;
}

.hero-content {
  flex: 1;
  min-width: 0;
}

.hero-badge {
  display: inline-block;
  background: linear-gradient(135deg, #fff3e0, #ffe0b2);
  color: #e65100;
  font-size: 13px;
  font-weight: 600;
  padding: 6px 14px;
  border-radius: 20px;
  margin-bottom: 24px;
  border: 1px solid #ffcc80;
}

.hero-title {
  font-size: 42px;
  font-weight: 800;
  color: #1a202c;
  line-height: 1.25;
  margin: 0 0 20px;
  letter-spacing: -0.5px;
}

.hero-desc {
  font-size: 17px;
  color: #4a5568;
  line-height: 1.8;
  margin: 0 0 36px;
}

.hero-desc strong {
  color: var(--primary);
  font-weight: 600;
}

.hero-actions {
  display: flex;
  gap: 16px;
  align-items: center;
  margin-bottom: 48px;
}

.btn-outline {
  display: inline-flex;
  align-items: center;
  color: var(--primary);
  font-weight: 600;
  font-size: 16px;
  padding: 14px 28px;
  border-radius: 12px;
  text-decoration: none;
  border: 2px solid rgba(78, 140, 255, 0.35);
  transition: all 0.3s ease;
}

.btn-outline:hover {
  background: rgba(78, 140, 255, 0.06);
  border-color: var(--primary);
}

.hero-stats {
  display: flex;
  align-items: center;
  gap: 0;
  background: rgba(255, 255, 255, 0.7);
  border-radius: 16px;
  padding: 20px 32px;
  backdrop-filter: blur(8px);
  border: 1px solid rgba(78, 140, 255, 0.12);
}

.stat-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
}

.stat-num {
  font-size: 28px;
  font-weight: 800;
  color: var(--primary);
  line-height: 1;
  margin-bottom: 4px;
}

.stat-label {
  font-size: 13px;
  color: #718096;
  font-weight: 500;
}

.stat-divider {
  width: 1px;
  height: 40px;
  background: rgba(78, 140, 255, 0.15);
  margin: 0 8px;
}

/* 右侧截图 */
.hero-image {
  flex: 1.1;
  min-width: 0;
}

.image-container {
  position: relative;
  display: inline-block;
  width: 100%;
}

.hero-image img {
  width: 100%;
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(0,0,0,0.04);
  display: block;
  transition: opacity 0.3s ease;
}

.image-navigation .nav-button {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(255, 255, 255, 0.9);
  border: none;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.25s ease;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  color: #333;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(8px);
}

.image-navigation .nav-button:hover {
  background: #fff;
  transform: translateY(-50%) scale(1.1);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
}

.image-navigation .prev { left: -22px; }
.image-navigation .next { right: -22px; }

.image-indicators {
  display: flex;
  justify-content: center;
  margin-top: 16px;
  gap: 8px;
}

.image-indicators span {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #d0d7e2;
  cursor: pointer;
  transition: all 0.3s ease;
}

.image-indicators span.active {
  background: var(--primary);
  width: 24px;
  border-radius: 4px;
  box-shadow: 0 0 8px rgba(78, 140, 255, 0.5);
}

@media (max-width: 900px) {
  .container {
    flex-direction: column;
    gap: 40px;
    padding: 120px 20px 60px;
  }
  .hero-title {
    font-size: 30px;
  }
  .hero-image img {
    max-width: 100%;
  }
  .image-navigation .prev { left: 8px; }
  .image-navigation .next { right: 8px; }
  .image-navigation .nav-button {
    width: 36px;
    height: 36px;
  }
}
</style>
